import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import {
  deactivateUserPostApi,
  getDeliveryInfoApi,
  getDeliveryListApi,
  getWalletInfoDeliverApi,
} from "../../../../Api/PanelAdminServices";
import { separate } from "../../../../Utils/SeprateNumber/SeprateThreeNumber";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Button from "../../../Button/Button";
import DeliveryInfo from "../../../Modal/Information/DeliveryInfo/DeliveryInfo";
import ShabaModal from "../../../Modal/Information/ShabaModal/ShabaModal";
import WalletInfo from "../../../Modal/Information/WalletInfo/WalletInfo";
import TableFixedPage from "../../../TableFixedPage/TableFixedPage";
import DriverListTabel from "../../../Tables/UserPart/UserList/DriverListTabel/DriverListTabel";

const DriverListContainer = () => {
  /////////get data //////
  const [deliveryList, setDeliveryList] = useState([]);
  useEffect(() => {
    DeliverList();
  }, []);
  const DeliverList = async () => {
    getDeliveryListApi((succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setDeliveryList(res.delivery);  
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    })
  };
  const [rawInfo, setRawInfo] = useState();

  // const DriverList=deliveryList.filter(e=>e.role==='role')


  const [deleteVisible, setDeleteVisible] = useState(false);
  const [editVisible, setEditVisible] = useState(false);
  const [userId, setUserId] = useState();
  const [wallet, setWallet] = useState();
  const [shabaAvailable, setShabaAvailable] = useState(false);
  const [scoreVisible, setScoreVisible] = useState(false);
  const [infoVisible, setInfoVisible] = useState(false);
  const [Info, setInfo] = useState(false);
  const [disable, setDisable] = useState(false);
  let history = useHistory();
  const showAddress = async (id, info) => {
    getDeliveryInfoApi(info.key,(succ,res)=>{
      if(succ){
        if(res.status===0){
          errorToast("مشکلی پیش آمده است")
        }else{
          setInfo(res.info);
          setUserId(info.key);
          setRawInfo(info);
        }
      }else{
        errorToast("خطایی در سرور رخ داده است")
      }
    });

    /////Edit///////
    if (id === 1) {
      setEditVisible(true);
      history.push(`/editdriverinfo/${info.key}`, info.key);
    }

    //////Delete///////
    if (id === 2) {
      setDeleteVisible(true);
    }

    //////info////////
    if (id === 3) {
      setInfoVisible(true);
    }

    //////shaba part////////
    if (id === 4) {
      setShabaAvailable(true);
    }

    /////wallet/////////
    if (id === 5) {
      getWalletInfoDeliverApi(info.key,(succ,res)=>{
        if(succ){
          if(res.status===0){
            errorToast("مشکلی پیش امده است")
          }else{
            res.transactions.sort((a,b)=>{
              if(a.id>b.id){
                return -1
              }else return 1
            })
            setWallet(res.transactions);
            setScoreVisible(true);
          }
        }else{
          errorToast("خطایی در سرور رخ داده است")
        }
      })
    }
  };
  const deactiveCustomer = () => {
    setDisable(true)
    let info = {
      id: userId,
      status: rawInfo.status === "0" ? "1" : "0",
      type: "deliver",
    };
    deactivateUserPostApi(info, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت انجام شد");
        setDisable(false)
        setDeleteVisible(false);
      } else {
        errorToast("مشکلی پیش آمد");
        setDisable(false)
        setDeleteVisible(false);
      }
    });
    DeliverList();
  };
  const handleOkAddress = () => {
    setDeleteVisible(false);
    setEditVisible(false);
    setInfoVisible(false);
    setShabaAvailable(false);
    setScoreVisible(false);
  };
  const data =
    deliveryList &&
    deliveryList.map((item) => {
      return {
        key: item.id,
        name: item.first_name + ' '+item.last_name,
        phone: item.phone,
        signUpDate: item.register_date,
        status: item.status,
        totalOrder: item.total_order,
        money: separate(parseInt(item.deposited) + parseInt(item.withdrawaled)),
      };
    });
  const TitleStyle = {
    width: "100%",
    color: "#c20c64",
    textAlign: "center",
  };
  return (
    <div>
      <Modal show={deleteVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>
            آیا از غیرفعال کردن کاربر موردنظر مطمئن هستید؟
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-around",
            }}
          >
            <Button
              ClassBtn={"rejectBtn"}
              Value={"خیر"}
              ClickHandler={handleOkAddress}
            />
            <Button
              ClassBtn={"confirmBtn"}
              Value={"بله"}
              ClickHandler={deactiveCustomer}
              disabledprops={disable}
            />
          </div>
        </Modal.Body>
      </Modal>

      <Modal show={infoVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>اطلاعات رساننده</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <DeliveryInfo Info={Info} handleOk={handleOkAddress} />
        </Modal.Body>
      </Modal>
      <Modal show={shabaAvailable} onHide={handleOkAddress}>
        <Modal.Body>
          <ShabaModal type={"deliver"} data={Info} />
        </Modal.Body>
      </Modal>
      <Modal show={scoreVisible} onHide={handleOkAddress}>
        <Modal.Header>
          <Modal.Title style={TitleStyle}>تراکنشات</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <WalletInfo data={wallet} />
        </Modal.Body>
      </Modal>
      <TableFixedPage title="لیست رسانندگان" />
      <DriverListTabel showAddress={showAddress} data={data} />
    </div>
  );
};

export default DriverListContainer;
